import axios from 'app/helpers/MyAxios';
import * as Types from './types';

export default {
  fetchManual: () =>
    dispatch => axios.get(axios.addApiUrl(`manual/manual`))
      .then((response) => {
        dispatch({ type: Types.FETCH_MANUAL, manual: response.data });
        return response.data;
      }),
};
